module.exports = require("highlight.js");